import { render, staticRenderFns } from "./Div_archiv.vue?vue&type=template&id=79a426f8"
import script from "./Div_archiv.vue?vue&type=script&lang=js"
export * from "./Div_archiv.vue?vue&type=script&lang=js"
import style0 from "./Div_archiv.vue?vue&type=style&index=0&id=79a426f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports